function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0;}.cls-2{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M0,0H24V24H0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M0,0H24V24H0Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18,8H16.97V6.02a5.015,5.015,0,1,0-10.03,0V8H6a1.99957,1.99957,0,0,0-2,2.00012v10a1.99946,1.99946,0,0,0,2,2H18a2.00587,2.00587,0,0,0,2-2v-10A2.006,2.006,0,0,0,18,8ZM7.94,6.02a4.015,4.015,0,1,1,8.03,0V8H7.94ZM19,20.00012a1.003,1.003,0,0,1-1,1H6a.99658.99658,0,0,1-1-1v-10a.9965.9965,0,0,1,1-1H18a1.00291,1.00291,0,0,1,1,1Z"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.99636,
  cy: 15,
  r: 2
});

var SvgLockOutline = function SvgLockOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock_outline.1ea1c3ff.svg";
export { ForwardRef as ReactComponent };